import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { UserDetails } from '@models/admin-users';
import { CommonService } from '@services/common-service';
import { ToastService } from '@services/toastService/toastMessage.service';
import { Time } from '@utilities/time';
import { NzModalService } from 'ng-zorro-antd/modal';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-add-users',
    templateUrl: './add-users.component.html',
    styleUrls: ['./add-users.component.scss']
    // see styles/ng-zorro/nz-modal.scss for global styles
    ,
    standalone: false
})
export class AddUsersComponent implements OnInit, OnChanges {

  @Input() addUsersVisible;

  @Input() editUserDetails = {} as UserDetails;

  @Input() isNewUser;

  @Output() closeAddUsers: EventEmitter<any> = new EventEmitter<any>();

  @Output() updatedDetails: EventEmitter<any> = new EventEmitter<any>();

  currentSsoId;

  roles;

  roleFilterApi;

  dateTrained;

  searchAccessRadioValue = null;

  searchRoleAccess = false;

  // invalidEmail = false;
  constructor(
    private toastService: ToastService,
    private modalService: NzModalService,
    private cService: CommonService
  ) { }

  ngOnInit() {

    this.roleFilterApi = environment.getFilterListURL;
    this.getRoleFilters();

    // this.createUserObj();
  
  }

  ngOnChanges() {

    if (this.editUserDetails && !this.isNewUser) {

      this.currentSsoId = this.editUserDetails.ssoId;

      if(this.editUserDetails.searchAccessActive == true) {

        this.searchAccessRadioValue = 'Yes';
      
      } else if(this.editUserDetails.searchAccessActive == false) {

        this.searchAccessRadioValue = 'No';
      
      } else {

        this.searchAccessRadioValue = null;
      
      }

      if(this.editUserDetails.searchRole === 'Standard') {

        this.searchRoleAccess = true;
      
      }
    
    }
    if (!this.editUserDetails || !this.editUserDetails.ssoId) {

      this.editUserDetails = {} as UserDetails;
      this.createUserObj();
    
    }  
  }

  createUserObj() {

    this.editUserDetails.name = {
      firstName: '',
      lastName: '',
      middleName: '',
      preferredName: ''
    };
    this.editUserDetails.email = {
      workEmail: '',
      personalEmail: '',
      alternateEmail: ''
    };
    this.editUserDetails.role = '';
    this.editUserDetails.workInfo = {
      jobTitle: '',
      company: '',
      division: '',
      group: '',
      building: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      country: ''
    };
    this.editUserDetails.organization = '';
    this.editUserDetails.parentOrganizationId = '';
    this.editUserDetails.ldapActive = true;
    this.editUserDetails.userSettings = {
      notifyConnectedSummaries: true,
      notifyConnections: true,
      notifyFlaggedUpdates: false,
      notifyFollowing: true,
      notifyHotAlerts: true,
      notifyImportantUpdates: true,
      notifyReadyUpdates: true,
      notifyStandardUpdates: true,
      enableDarkMode: false,
      searchRelevancy: false,
      showDivision: true,
      showJobTitle: true,
      showMobilePhone: true,
      showWorkLocation: true,
      showWorkPhone: true,
      showPersonalizedColumn: true
    };

    this.editUserDetails.ssoId = null;
    this.editUserDetails.prodReqRole = [];
  
  }

  handleOk() {

    if (!this.validateUserObject(this.editUserDetails)) {

      return;
    
    }

    if(!this.editUserDetails.searchAccessActive || this.editUserDetails.searchAccessActive === null) {
      this.editUserDetails.searchRole = null;
      this.editUserDetails.searchAccess = null;
    }

    // this.closeAddUsers.emit(true);
    if (this.editUserDetails.role !== this.currentSsoId) {

      if (this.showConfirm()) {

        this.updatedDetails.emit(this.editUserDetails);
      
      } else {


        // this.closeAddUsers.emit(true);
        return;
      
      }
    
    }
    this.updatedDetails.emit(this.editUserDetails);
  
  }

  handleCancel() {
    console.log('handleCancel');
    this.searchRoleAccess = false;
    this.searchAccessRadioValue = null;
    this.editUserDetails = {} as UserDetails;
    this.closeAddUsers.emit(true);
  }

  toUpperCase(value) {

    if (value === 'ReadOnly' || value === 'READ_ONLY' || value === 'Read_Only_user' || value === 'READ_ONLY_USER') {

      value = 'READ_ONLY';
    
    }
    return (value) ? value.toString().toUpperCase() : value;
  
  }

  toggleUserRole(value) {

    this.editUserDetails.role = value;
  
  }

  toggleSearchRole(value: string) {
      console.log('toggleSearchRole: ' + value);
      this.editUserDetails.searchRole = value;
      if (value === 'Standard') {
                this.searchRoleAccess = true;
      }
      else {
              this.searchRoleAccess = false;
              this.editUserDetails.searchAccess = null;
      }
  }

  toggleSearchAccess(value)
  {
    this.editUserDetails.searchAccess = value;
    console.log('toggleSearchAccess: ' + value);
  }

  toggleProdReqUserRole(value: []) {

    this.editUserDetails.prodReqRole = value;
    console.log('this.editUserDetails.prodReqRole' + this.editUserDetails.prodReqRole);
  
  }

  showConfirm(): any {

    this.modalService.confirm({
      nzTitle: '<i>Do you want to continue with the changes?</i>',
      nzOnOk: () => {

        this.updatedDetails.emit(this.editUserDetails);
        this.closeAddUsers.emit(true);
        return true;
      
      },
      nzOnCancel: () => {


        // this.closeAddUsers.emit(true);
        return true;
      
      }
    });
  
  }

  // emailValidation(workEmail: string) {
  //   if (workEmail !== null || workEmail !== undefined || workEmail !== "") {
  //     const pattern = RegExp(
  //       "^[-a-zA-Z0-9\.\_]+@(nbcuni.com|msnbc.com|cnbc.com|cnbcasia.com|telemundo.com|nbc.com|sky.uk|golfchannel.com|eentertainment.com|mail.newsconnect.nbcnews.com|localhost)$"
  // ); if (pattern.test(workEmail)) { this.invalidEmail = false; } else { this.invalidEmail = true; } } }

  searchAccess(event) {

    if(event === 'Yes') {

      this.editUserDetails.searchAccessActive = true;
    
    } else if(event === 'No') {

      this.editUserDetails.searchAccessActive = false;
    
    } else{

      this.editUserDetails.searchAccessActive = null;
    
    }
    console.log('searchAccess: '+this.editUserDetails.searchAccessActive);
    console.log('editUserDetails.searchRole: '+this.editUserDetails.searchRole);
  
  }

  validateUserObject(editUserDetails) {


    // const pattern = RegExp(
    //   "^[-a-zA-Z0-9\.\_]+@(nbcuni.com|msnbc.com|cnbc.com|cnbcasia.com|telemundo.com|nbc.com|sky.uk|golfchannel.com|eentertainment.com|mail.newsconnect.nbcnews.com|localhost)$"
    // );
    if (editUserDetails.name.firstName === '') {

      this.toastService.createMessage('warning', 'Please Provide the First Name');
      return false;
    
    } else if (editUserDetails.name.lastName === '') {

      this.toastService.createMessage('warning', 'Please Provide the Last Name');
      return false;
    
    } else if (!editUserDetails.role) {

      this.toastService.createMessage('warning', 'Please Provide the Role');
      return false;
    
    } else if (!editUserDetails.ssoId) {

      this.toastService.createMessage('warning', 'Please Provide a valid SSO ID');
      return false;
    
    } else if (editUserDetails.ssoId.length > 9 || editUserDetails.ssoId.length < 9) {

      this.toastService.createMessage('warning', 'SSO ID should be of 9 Numbers');
      return false;
    
    } else if (!editUserDetails.ssoId.toString().match('^[0-9]*$')) {

      this.toastService.createMessage('warning', 'SSO ID should be of Numbers');
      return false;

      // } else
      //   if(!pattern.test((editUserDetails.email.workEmail))){
      //     this.toastService.createMessage('warning', 'Please enter a valid NBCU email address');
      //     this.invalidEmail = true;
      //   }
    
    }
    else if (editUserDetails.searchAccessActive && (editUserDetails.searchRole === '' || editUserDetails.searchRole === null)) {

      this.toastService.createMessage('warning', 'Please Provide the Search Role');
      return false;
    
    }
    else if (editUserDetails.searchAccessActive && editUserDetails.searchRole === 'Standard' && (!editUserDetails.searchAccess || editUserDetails.searchAccess.length === 0)) {

      this.toastService.createMessage('warning', 'Please Provide the Search Access');
      return false;
    
    }
    else {

      return true;
    
    }
  
  }

  addUser() {

    if (!this.validateUserObject(this.editUserDetails)) {

      return;
    
    } else {

      this.updatedDetails.emit(this.editUserDetails);
    
    }
    this.closeAddUsers.emit(true);
  
  }

  getRoleFilters() {

    this.cService.serviceRequestCommon('get', this.roleFilterApi).subscribe((res: any) => {

      this.roles = res.data.roles;
      console.log('User Role Details', this.roles, res.data.roles);
    
    },
    (err) => {

      this.toastService.createMessage('error', err);
    
    });
  
  }

  onChange(event, dateType) {

    if (dateType === 'TRAINED_DATE' && event) {

      this.dateTrained = Time.convertLocalToUTC(event);
      this.editUserDetails.dateTrained = this.dateTrained;
    
    } else if (dateType === 'TRAINED_DATE' && !event) {

      this.dateTrained = '';
      this.editUserDetails.dateTrained = this.dateTrained;
    
    }

  }

}
